var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 90.974v90h-211c-16.5 0-30-43.5-30-60s13.5-30 30-30z",
    fill: "#285059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.217 176.521-25.679-67.813-113.117-52.694-84.421 30.734-226.352 82.038c-6.855 2.49-10.928 9.536-9.639 16.714 1.26 7.163 7.5 12.378 14.766 12.378h.029l221.196-.632 209.154-.599c4.893-.015 9.463-2.402 12.275-6.416 2.784-3.998 3.458-9.125 1.788-13.71z",
    fill: "#5ce6b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.43 190.232c2.783-3.999 3.457-9.126 1.787-13.711l-25.679-67.813-113.117-52.694-84.421 30.734v110.499l209.154-.599c4.893-.015 9.463-2.403 12.276-6.416z",
    fill: "#3dccb4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 165.974v300c0 8.399-6.599 15-15 15h-422c-24.901 0-45-20.101-45-45v-315c0 16.5 13.5 30 30 30h437c8.401 0 15 6.599 15 15z",
    fill: "#3f6a73"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m482 165.974v300c0 8.399-6.599 15-15 15h-226v-330h226c8.401 0 15 6.599 15 15z",
    fill: "#285059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.736 32.443c-3.574-1.699-7.705-1.875-11.455-.498l-68.86 24.069c4.076 25.199 19.402 44.601 37.806 54.736 22.773 12.515 51.013 12.625 75.311-2.042l-25.038-67.799c-1.348-3.735-4.16-6.782-7.764-8.466z",
    fill: "#5ce6b8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166 300.974c-7.705 0-15-8.262-15-17.007 0-6.498 5.383-13.42 15-14.703 4.891-.654 11.942.157 19.57 7.54 5.947 5.801 15.439 5.625 21.211-.322 5.742-5.947 5.596-15.454-.352-21.211-7.513-7.289-16.313-11.942-25.43-14.33v-14.967c0-8.291-6.709-15-15-15s-15 6.709-15 15v16.45c-19.598 7.438-30 24.452-30 41.543 0 25.474 20.596 47.007 45 47.007 7.236 0 15 4.072 15 12.993 0 7.886-6.011 15.311-15 14.921-6.028-.258-12.49-4.091-18.516-11.259-5.332-6.343-14.795-7.163-21.123-1.831-6.357 5.332-7.178 14.795-1.846 21.138 7.863 9.357 16.985 15.551 26.484 18.973v20.065c0 8.291 6.709 15 15 15s15-6.709 15-15v-19.523c.222-.077.452-.04.674-.121 17.551-6.386 29.328-23.408 29.328-42.363 0-24.507-19.336-42.993-45-42.993z",
    fill: "#5ce6b8"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467 390.974h-91c-41.367 0-75-33.647-75-75s33.633-75 75-75h91c24.814 0 45 20.186 45 45v60c0 24.814-20.186 45-45 45z",
    fill: "#3f6a73"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 315.974,
    fill: "#fb3",
    r: 15
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.a2d972ddc85f58849d40030e10536144.svg";
export { ForwardRef as ReactComponent };